export {
  NavCategoryItemProvider,
  useNavCategoryItemContext_unstable as useNavCategoryItemContext,
} from '@fluentui/react-nav';

export type { NavCategoryItemContextValue } from './NavCategoryItem/NavCategoryItem.types';
